<template>
  <div class="page-container">
    
    <div class="data-filter">
      <div class="data-filter-buttons">
        <el-radio-group v-model="pagination.filter" size="mini"  @change="filterHandler">
          <el-radio-button :label="null">필터없음</el-radio-button>
          <el-radio-button :label="1">무료고객</el-radio-button>
          <el-radio-button :label="2">유료고객</el-radio-button>
          <el-radio-button :label="3">만료된 고객</el-radio-button>
          <el-radio-button :label="4">만료되지 않은 고객</el-radio-button>
          <el-radio-button :label="5">커스텀결제 사용 고객</el-radio-button>
        </el-radio-group>
      </div>
      <div class="data-filter-search">
        <el-input
          placeholder="고객 아이디 또는 회사이름 검색"
          v-model="pagination.search"
          size="mini"
          clearable
          @keyup.enter.native="searchHandler"
          @clear="clearHandler">
        </el-input>
      </div>
      <div class="data-filter-buttons">
        &nbsp;&nbsp;<el-button size="mini" type="danger" @click="userAddOpenHandler">계정 추가</el-button>
      </div>
    </div>

    <div class="data-table">
      <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
        <el-table-column type="index" :index="rowIndex" width="100"></el-table-column>
        <el-table-column width="50" label="메모">
          <template slot-scope="scope">
            <el-popover width="340" trigger="click" @show="getMemo(scope.row.company)">
              <div>
                <el-table :data="scope.row.company.memo" :show-header="false" size="mini" empty-text="메모가 없습니다">
                  <el-table-column prop="memo"></el-table-column>
                </el-table>
              </div>
              <i slot="reference" class="el-icon-notebook-2 show-memo-btn"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="회사이름">
          <template slot-scope="scope">       
            <router-link 
              class="el-link el-link--info is-underline" 
              :to="{
                name: 'management-detail', 
                params: {
                  company_pk: scope.row.company.pk,
                  back: { name: $route.name, pagination }
                }}">
              <span class="el-link--inner" v-if="scope.row.company.company_name">{{ scope.row.company.company_name }}</span>
              <span class="el-link--inner dimmed-text" v-else>{{ scope.row.manager.mgrid }} (개인 사용자)</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="가입일" width="120">
          <template slot-scope="scope">{{ scope.row.company.join_date | moment('YYYY-MM-DD') }}</template>
        </el-table-column>
        <el-table-column label="만료일" width="120">
          <template slot-scope="scope">{{ scope.row.company.expire_date | moment('YYYY-MM-DD') }}</template>
        </el-table-column>
        <el-table-column prop="company.last_payment_type" label="결제타입" width="100"></el-table-column>
        <el-table-column label="관리자">
          <template slot-scope="scope">
            <el-popover placement="left" width="400" trigger="click">
              <ul class="manager-information">
                <li>
                  <div class="label">아이디</div>
                  <div class="value">{{ scope.row.manager.mgrid }}</div>
                </li>
                <li>
                  <div class="label">이메일 ( {{scope.row.manager.email_auth === 1 ? '인증됨' : '인증안됨'}} )</div>
                  <div class="value">{{ scope.row.manager.email }}</div>
                </li>
                <li>
                  <div class="label">전화번호</div>
                  <div class="value">{{ scope.row.manager.phone }}</div>
                </li>
                <li>
                  <div class="label">웹사이트</div>
                  <div class="value">
                    <a v-if="scope.row.company.website" :href="scope.row.company.website" target="_blank">{{ scope.row.company.website }}</a>
                    <span v-else>웹사이트 없음</span>
                  </div>
                </li>
              </ul>
              <el-button slot="reference" size="mini">{{ scope.row.manager.name }} ({{ scope.row.manager.mgrid }})</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="data-pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :current-page.sync="pagination.page"
        @current-change="pageHandler">
      </el-pagination>
    </div>

    <el-dialog
      :visible.sync="dialog.show"
      width="30%"
      center>
      <template slot="title">
        <img class="modal-logo-image" src="@/assets/logo.png">
      </template>
      <div>
        <el-form ref="useradd" :model="dialog.form" label-width="120px" :rules="dialog.rules">
          <el-form-item label="아이디" prop="mgrid">
            <el-input v-model="dialog.form.mgrid" autocomplete="off"/>
          </el-form-item>
          <el-form-item label="비밀번호" prop="mgrpw">
            <el-input v-model="dialog.form.mgrpw" type="password" autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="이름" prop="name">
            <el-input v-model="dialog.form.name" autocomplete="off"/>
          </el-form-item>
          <el-form-item label="이메일" prop="email">
            <el-input v-model="dialog.form.email" type="email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="전화번호" prop="phone">
            <el-input v-model="dialog.form.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="회사이름" prop="company_name">
            <el-input v-model="dialog.form.company_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="홈페이지" prop="company_website">
            <el-input v-model="dialog.form.company_website" autocomplete="off"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="승인 프로세스" prop="approval">
                <el-switch v-model="dialog.form.approval"></el-switch>
                <el-popover width="360" trigger="click" class="approval_popup">
                  <div>
                    <h3>원격제어 승인 프로세스란</h3>
                    <p>
                      원격제어 승인 프로세스는 사용자가 관리자 또는 매니저에게 장치 접근 요청을 하고,
                      승인이 된 사용자만 원격제어를 할 수 있는 동작방식입니다.<br><br>
                      자세한 내용은 사용자 매뉴얼을 참고하십시오.
                    </p>
                  </div>
                  <i slot="reference" class="fas fa-question-circle fa-lg"></i>
                </el-popover>
              </el-form-item>
              <el-form-item label="정책관리 사용" prop="common_policy">
                <el-switch v-model="dialog.form.common_policy"></el-switch>
              </el-form-item>
              <el-form-item
                  label="하위사용자 수"
                  prop="manager_limit"
                  :rules="[
                    { required: true, message: '필수 항목 입니다.'},
                    { type: 'number', message: '숫자만 입력 가능합니다.'}
                  ]"
              >
                <el-input v-model.number="dialog.form.manager_limit" autocomplete="off" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="계정 활성화" prop="enable">
                <el-switch v-model="dialog.form.enable"></el-switch>
              </el-form-item>
              <el-form-item label="접속IP관리 사용" prop="ip_policy">
                <el-switch v-model="dialog.form.ip_policy"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="dialog.loading" @click="userAddSubmitHandler">확인</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  methods: {
    async getManagers () {
      console.log('GET MANAGERS')
      try {
        this.loading = true
        let params = { offset: this.pagination.offset, limit: this.pagination.limit }
        if (this.pagination.search) params.search = this.pagination.search
        if (this.pagination.filter !== null) params.filter = this.pagination.filter

        let response = await this.$http.get('managers', {params})
        this.pagination.total = response.data.total
        this.list = response.data.list.map(v => {
          v.company.memo = []
          return v
        })
        
        this.loading = false
        return response
      }
      catch (e) {
        console.error(e)
      }
    },
    async getMemo (company) {
      console.log('[GET MEMO]')
      if (company.memo.length) return;
      let query = {
        filters: [{name: 'company_fk', op: 'eq', val: company.pk}],
        order_by: [{ field: 'create_time', direction: 'desc' }]
      }
      let params = { results_per_page: 5, page: 1, q: JSON.stringify(query)  }
      let response = await this.$http.get('memo', {params})
      company.memo = response.data.objects
    },
    rowIndex (index) {
      let {total, offset} = this.pagination
      return total - (offset + index)
    },
    pageHandler (page) {
      this.pagination.offset = this.pagination.limit * (page - 1)
      this.getManagers()
    },
    searchHandler () {
      this.pagination.offset = 0
      this.pagination.page = 1
      this.getManagers()
    },
    filterHandler () {
      this.getManagers()
    },
    clearHandler () {
      this.pagination.search = null
      if (this.$route.query.search) {
        this.$router.replace({query: {}})
      }
      else this.getManagers()
    },
    userAddOpenHandler () {
      this.dialog.loading = false

      this.dialog.form.mgrid = ''
      this.dialog.form.mgrpw = ''
      this.dialog.form.name = ''
      this.dialog.form.email = ''
      this.dialog.form.phone = ''
      this.dialog.form.company_name = ''
      this.dialog.form.company_website = ''
      this.dialog.form.enable = true,
      this.dialog.form.pcany_user = false,
      this.dialog.form.approval = false,
      this.dialog.form.common_policy = false,
      this.dialog.form.ip_policy = false

      this.dialog.show = true
      if (this.$refs.useradd) this.$refs.useradd.resetFields()
    },
    userAddSubmitHandler () {
      this.$refs.useradd.validate(async (valid) => {
        if (!valid) return false
        this.dialog.loading = true    
        
        try {
          await this.$http.post('managers', this.dialog.form)
          this.dialog.show = false
          this.dialog.loading = false
          this.$service.$emit('alert-modal', '계정 등록이 성공했습니다')
          this.getManagers()
          return true
        }
        catch (e) {
          console.error(e)
          this.dialog.loading = false
          return false
        }
      })
    },
  },
  watch: {
    '$route.query.search' (n, o) {
      if (n !== o) {
        this.pagination.search = this.$route.query.search
        this.pagination.total = 0
        this.pagination.limit = 10
        this.pagination.offset = 0
        this.pagination.page = 1
        this.pagination.filter = null
        this.getManagers()
      }
    }
  },
  mounted () {
    if (this.$route.params.restore) {
      this.pagination.total = this.$route.params.restore.pagination.total
      this.pagination.limit = this.$route.params.restore.pagination.limit
      this.pagination.offset = this.$route.params.restore.pagination.offset
      this.pagination.page = this.$route.params.restore.pagination.page
      this.pagination.filter = this.$route.params.restore.pagination.filter
      this.pagination.search = this.$route.params.restore.pagination.search
      delete this.$route.params.restore
    }
    else if (this.$route.query.search) {
      this.pagination.search = this.$route.query.search
      // this.$router.replace({query: {}})
    }
    
    this.getManagers()
  },
  data () {
    return {
      loading: false,
      pagination: {
        search: null,
        total: 0,
        limit: 10,
        offset: 0,
        filter: null,
        page: 1
      },
      list: [],
      dialog: {
        show: false,
        loading: false,
        rules: {
          mgrid: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('아이디를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9]{1,48}$/.test(v)) cb(new Error('아이디는 영문, 숫자를 포함하여 48까지 가능합니다')); else cb() }},
            {validator: async (r, mgrid, cb) => {
              let {data} = await this.$http.post('exist_user', { mgrid })
              if (data === 'OK') cb()
              else cb(new Error('이미 존재하는 아이디입니다'))
            }}
          ],
          mgrpw: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('비밀번호를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9!~@#$%^&*()?+=\/]{1,48}$/.test(v)) cb(new Error('비밀번호는 영문, 숫자, 특수문자를 포함하여 48자까지 가능합니다')); else cb() }}
          ],
          name: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('이름를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/^[a-zA-Z0-9가-힣]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          email: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('이메일을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (!/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(v)) cb(new Error('올바른 이메일을 입력해 주세요')); else cb() }}
          ],
          phone: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('전화번호를 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (v && !/^[0-9-]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          company_name: [
            {validator: (r, v, cb) => { if (!v) cb(new Error('회사이름을 입력해 주세요')); else cb(); }},
            {validator: (r, v, cb) => { if (v && !/^[a-zA-Z0-9가-힣]+$/.test(v)) cb(new Error('포함할 수 없는 글자가 있습니다')); else cb() }}
          ],
          company_website: [
            {validator: (r, v, cb) => { if (v && !/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig.test(v)) cb(new Error('올바른 홈페이지 주소를 적어주세요')); else cb() }}
          ]
        },
        form: {
          mgrid: '',
          mgrpw: '',
          name: '',
          email: '',
          phone: '',
          company_name: '',
          company_website: '',
          enable: true,
          pcany_user: false,
          approval: false,
          common_policy: false,
          ip_policy: false,
          manager_limit: 1,
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-information {
  list-style: none;
  padding: 0; margin: 0;

  > li {
    padding: 4px 10px;
    > div { display: inline-block; }
    > .label {
      width: 160px;
      color: #a0a0a0;
    }
  }
}
.data-pagination {
  text-align: center;
  background-color: white;
  padding: 4px 10px;
}

.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
.show-memo-btn {
  font-size: 22px;
  cursor: pointer;
}
.fas{
  vertical-align: middle;
  cursor: pointer;
}
.approval_popup{
  margin-left: 10px;
}
</style>
